import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import { ToastContainer, toast } from "react-toastify";
import { Formik } from "formik";
import { Link, useParams } from "react-router-dom";
import { vehicleUpdateAddon } from "../../redux/action/vehicle";
import { useDispatch } from "react-redux";
import axios from "axios";
import { APIURL } from "../../redux/action/config";

const EditRentalAddOn = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const [vehicleAddonDetails, setvehicleAddonDetailsDetails] = useState();
  const [checked, setChecked] = useState();
  useEffect(() => {
    if (!id) return;
    setLoading(true);
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(`${APIURL}/api/v1/price/${id}`, config)
      .then((response) => {
        setvehicleAddonDetailsDetails(response?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);
  useEffect(() => {
    setChecked(vehicleAddonDetails?.data?.price?.isChecked);
  }, [vehicleAddonDetails]);
  const [loadingBtn, setLoadingBtn] = useState(false);

  return (
    <React.Fragment>
      <Layout title="Edit Addon" page="edit-addon">
        <ToastContainer autoClose={2000} />
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row">
              <div className="col-xl-8 offset-xl-2">
                <div className="card card-flush h-lg-100">
                  <div className="card-header pt-7">
                    <div className="card-title">
                      <span className="svg-icon svg-icon-1 me-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                            fill="black"
                          ></path>
                          <path
                            opacity="0.3"
                            d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                            fill="black"
                          ></path>
                        </svg>
                      </span>
                      <h2>Edit Addon</h2>
                    </div>
                  </div>
                  <div className="card-body pt-5">
                    <Formik
                      initialValues={{
                        addName: vehicleAddonDetails?.data?.price?.addName,
                        price: vehicleAddonDetails?.data?.price?.price
                          ? vehicleAddonDetails?.data?.price?.price
                          : "",
                        isChecked: vehicleAddonDetails?.data?.price?.isChecked,
                      }}
                      enableReinitialize={true}
                      onSubmit={(values) => {
                        const payload = {
                          ...values,
                          isChecked: checked,
                        };
                        setLoadingBtn(true);
                        console.log(payload, "payload==>");
                        dispatch(
                          vehicleUpdateAddon(payload, id, (res) => {
                            if (res === "success") {
                              toast.success(
                                "Add on item Updated Successfully!"
                              );
                              setTimeout(() => {
                                return (window.location.href =
                                  "/mange-rental-add-on");
                              }, 1000);
                            }
                            if (res === "error") {
                              setLoadingBtn(false);
                            }
                          })
                        );
                      }}
                    >
                      {({ values, handleBlur, handleChange, handleSubmit }) => (
                        <form className="form" onSubmit={handleSubmit}>
                          <div className="row mb-8">
                            <div className="col-xl-5">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Name of Addon
                              </div>
                            </div>
                            <div className="col-xl-7 fv-row fv-plugins-icon-container">
                              <input
                                type="text"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="addName"
                                id="addName"
                                defaultValue={
                                  vehicleAddonDetails?.data?.price?.addName
                                    ? vehicleAddonDetails?.data?.price?.addName
                                    : values.addName
                                }
                                className="form-control form-control-solid"
                              />
                              <div className="fv-plugins-message-container invalid-feedback"></div>
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-5">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Price
                              </div>
                            </div>
                            <div className="col-xl-7 fv-row fv-plugins-icon-container">
                              <input
                                type="number"
                                step="any"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="price"
                                id="price"
                                defaultValue={
                                  vehicleAddonDetails?.data?.price?.price
                                    ? vehicleAddonDetails?.data?.price?.price
                                    : values.price
                                }
                                className="form-control form-control-solid"
                              />
                            </div>
                          </div>
                          <div className="row mb-8">
                            <div className="col-xl-5">
                              <div className="fs-6 fw-bold mt-2 mb-3">
                                Quantity Management Required
                              </div>
                            </div>
                            <div className="col-xl-7 fv-row fv-plugins-icon-container d-flex align-items-center">
                              <input
                                type="checkbox"
                                onBlur={handleBlur}
                                name="isChecked"
                                id="isChecked"
                                checked={checked}
                                onChange={() => setChecked(!checked)}
                                className="form-check-input custum-check mx-0 my-3 form-control p-0"
                              />
                            </div>
                          </div>
                          <div className="separator mb-6"></div>
                          <div className="d-flex justify-content-end">
                            {/* <Link
                              to="/all-rentals"
                              type="reset"
                              className="btn btn-light me-3"
                            >
                              Cancel
                            </Link> */}
                            {!loadingBtn ? (
                              <button type="submit" className="btn btn-primary">
                                <span className="indicator-label">Save</span>
                              </button>
                            ) : (
                              <button
                                disabled={true}
                                className="btn btn-primary"
                                style={{ width: "60px" }}
                              >
                                <div
                                  className="spinner-border text-dark"
                                  style={{ height: "18px", width: "18px" }}
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </button>
                            )}
                          </div>
                          <div></div>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default EditRentalAddOn;
